import { gql } from '@apollo/client'

export const LEGAL_FORMALITIES_EXPORT_COMPLETIONS_MUTATION = gql`
  mutation LegalFormalitiesExportCompletions($email: String) {
    legalFormalitiesExportCompletions(email: $email) {
      message
    }
  }
`
